import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './_guards/auth.guard';
import {FirstLoginGuard} from './_guards/first-login.guard';
import {NotAuthorizedComponent} from './not-authorized/not-authorized.component';
import {TermsComponent} from './footer/terms/terms.component';
import {ResetPasswordComponent} from './admin/user-admin/reset-password/reset-password.component';
import {EditProfileComponent} from './admin/user-admin/edit-profile/edit-profile.component';
import {SiteMapComponent} from './site-map/site-map.component';
import {PasswordNotExpiredGuard} from './_guards/password-not-expired.guard';

export const defaultGuards = [AuthGuard, FirstLoginGuard, PasswordNotExpiredGuard];

const routes: Routes = [
  {path: 'not-authorized', pathMatch: 'full', component: NotAuthorizedComponent},
  {path: 'terms', pathMatch: 'full', component: TermsComponent},
  {path: 'resetpassword', pathMatch: 'full', component: ResetPasswordComponent, data: {tokenRequired: true}},
  // Careful if you change the path of password-expired since the ResetPassword component checks if that's the url for password expired logic
  {path: 'password-expired', pathMatch: 'full', component: ResetPasswordComponent, data: {tokenRequired: false}},
  {path: 'edit-profile', pathMatch: 'full', component: EditProfileComponent, canActivate: defaultGuards},
  {path: 'site-map', pathMatch: 'full', component: SiteMapComponent},

  //Lazy load the big modules when needed:
  {path: 'consumer-services', loadChildren: () => import('./consumer-services/consumer-services.module').then(m => m.ConsumerServicesModule)},
  {path: 'business-services', loadChildren: () => import('./business-services/business-services.module').then(m => m.BusinessServicesModule)},
  {path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    enableTracing: false // <-- set to true for debugging purposes only - DON'T CHECK IN IF SET TO TRUE
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
